import { LatLngBounds } from "@agm/core";
import { Component, Inject, OnInit } from "@angular/core";
import { FormBuilder } from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { InsertClientComponent } from "../../show-clients/insert-client/insert-client.component";

declare var google: any;

@Component({
  selector: "app-area-map-dialog",
  templateUrl: "./area-map-dialog.component.html",
  styleUrls: ["./area-map-dialog.component.scss"],
})
export class AreaMapDialogComponent implements OnInit {
  map: any;
  bounds: LatLngBounds;

  constructor(
    public dialogRef: MatDialogRef<InsertClientComponent>,
    @Inject(MAT_DIALOG_DATA) public data,
    private fb: FormBuilder
  ) {}

  ngOnInit(): void {}

  closeCancelling() {
    this.dialogRef.close();
  }

  onMapReady(map) {
    this.map = map;
    map.setOptions({ draggable: true, fullscreenControl: true });
    this.adjustBounds(this.data.object);
  }

  styleFunc(feature) {
    return {
      clickable: false,
      // fillColor: feature.getProperty('color'),
      fillColor: "rgba(0, 0, 0, 0.486)",
      strokeColor: "rgba(0, 0, 0, 0.400)",
      strokeWeight: 1,
    };
  }

  adjustBounds(area) {
    this.bounds = new google.maps.LatLngBounds();
    if (area.geoArea.geometry.type == "Polygon") {
      for (const mm of area.geoArea.geometry.coordinates[0]) {
        this.bounds.extend(new google.maps.LatLng(mm[1], mm[0]));
      }
    } else if (area.geoArea.geometry.type == "MultiPolygon") {
      for (const mm of area.geoArea.geometry.coordinates[0]) {
        for (const mm2 of mm) {
          this.bounds.extend(new google.maps.LatLng(mm2[1], mm2[0]));
        }
      }
    }
    this.map.fitBounds(this.bounds);
  }
}
